(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-servicebox"] && !Shopify.designMode) return;
  try {
    
// Script para inicializar Swiper corregido
document.addEventListener('DOMContentLoaded', function() {
  // Verificar si la sección existe
  const sectionElement = document.querySelector('.about-servicebox-swiper');
  if (!sectionElement) return;
  
  // Verificar si hay slides
  const slides = sectionElement.querySelectorAll('.swiper-slide');
  if (slides.length === 0) return;
  
  // Configuración del Swiper con valores por defecto
  const swiperOptions = {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  };
  
  // Configurar navegación si existen los elementos
  const nextButton = sectionElement.querySelector('.swiper-button-next');
  const prevButton = sectionElement.querySelector('.swiper-button-prev');
  if (nextButton && prevButton) {
    swiperOptions.navigation = {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    };
  }
  
  // Configurar paginación si existe el elemento
  const paginationEl = sectionElement.querySelector('.swiper-pagination');
  if (paginationEl) {
    swiperOptions.pagination = {
      el: '.swiper-pagination',
      clickable: true
    };
  }
  
  // Configurar autoplay por defecto
  swiperOptions.autoplay = {
    delay: 3500,
    disableOnInteraction: false
  };
  
  // Solo inicializar Swiper si está disponible
  if (typeof Swiper !== 'undefined') {
    try {
      new Swiper('.about-servicebox-swiper', swiperOptions);
      console.log('Swiper inicializado correctamente');
    } catch (error) {
      console.error('Error al inicializar Swiper:', error);
    }
  } else {
    // Si Swiper no está disponible, cargarlo dinámicamente
    loadSwiper();
  }
  
  // Función para cargar Swiper dinámicamente
  function loadSwiper() {
    // Verificar si ya está cargado
    if (typeof Swiper !== 'undefined') return;
    
    // Cargar CSS primero
    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(cssLink);
    
    // Cargar JS después
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = function() {
      // Reintentar inicialización después de cargar Swiper
      if (typeof Swiper !== 'undefined') {
        try {
          new Swiper('.about-servicebox-swiper', swiperOptions);
          console.log('Swiper cargado e inicializado dinámicamente');
        } catch (error) {
          console.error('Error al inicializar Swiper después de carga dinámica:', error);
        }
      }
    };
    script.onerror = function() {
      console.error('Error al cargar la librería Swiper');
    };
    document.head.appendChild(script);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-v1"] && !Shopify.designMode) return;
  try {
    
function initCollectionSlider() {
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) {
    console.log('collection-v1: slick or jQuery missing');
    return;
  }

  $('.section-collection-v1').each(function() {
    var $section = $(this);
    var $slider = $section.find('.js-collection-v1');
    var $prev = $section.find('.js-collection-prev');
    var $next = $section.find('.js-collection-next');
    var $dots = $section.find('.collection-dots');
    if (!$slider.length) {
      console.log('collection-v1: slider element not found');
      return;
    }

    var slidesDesktop = parseInt($slider.data('slides-desktop'), 10) || 3;
    var slidesTablet = parseInt($slider.data('slides-tablet'), 10) || 2;
    var slidesMobile = parseInt($slider.data('slides-mobile'), 10) || 1;
    var autoplay = String($slider.data('autoplay')) === 'true';
    var autoplaySpeed = parseInt($slider.data('autoplay-speed'), 10) || 3000;
    var arrows = String($slider.data('arrows')) === 'true';
    var dots = String($slider.data('dots')) === 'true';
    var infinite = String($slider.data('infinite')) === 'true';

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      console.log('collection-v1: re-init slick');
    }

    $slider.slick({
      slidesToShow: slidesDesktop,
      slidesToScroll: 1,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      arrows: arrows,
      prevArrow: $prev.length ? $prev : '<button type="button" class="slick-prev">Prev</button>',
      nextArrow: $next.length ? $next : '<button type="button" class="slick-next">Next</button>',
      appendArrows: $section.find('.collection-nav'),
      dots: dots,
      appendDots: $dots,
      infinite: infinite,
      adaptiveHeight: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: slidesTablet,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: slidesMobile,
            slidesToScroll: 1
          }
        }
      ]
    });

    console.log('collection-v1: slick initialized', {
      arrows: arrows,
      dots: dots,
      autoplay: autoplay,
      slidesDesktop: slidesDesktop,
      slidesTablet: slidesTablet,
      slidesMobile: slidesMobile
    });
  });
}

document.addEventListener('DOMContentLoaded', initCollectionSlider);
document.addEventListener('shopify:section:load', initCollectionSlider);
document.addEventListener('shopify:section:select', initCollectionSlider);

  } catch(e) { console.error(e); }
})();
})();
